module.exports = __webpack_public_path__ + "img/4hearts.0f3c1761.jpg";